import {ReactNode} from 'react';
import WindowFrame from '../windowFrame/WindowFrame';
import AccountRolePermission from '../../../components/rolePermission/AccountRolePermission';

type AccountWindowProps = {
    gridArea: string;
    title?: ReactNode;
    actions?: ReactNode;
    explanation?: ReactNode;
    explanationTitle?: string;
    explanationDataCy?: string;
    rolePermission?: string;
    variant?: 'account' | 'plain';
    height?: string;
    dataCy?: string;
    className?: string;
    children: ReactNode;
};

export default function AccountWindow({gridArea, title, actions, explanation, explanationTitle, explanationDataCy,
    rolePermission = 'manage package', variant = 'account', height, dataCy, className, children}: AccountWindowProps) {
    return (
        <AccountRolePermission rolePermission={rolePermission} views={[]}>
            <WindowFrame gridArea={gridArea} variant={variant} height={height} dataCy={dataCy} className={className}
                header={{title, start: actions, helper: explanation, helperTitle: explanationTitle, helperDataCy: explanationDataCy}}>
                {children}
            </WindowFrame>
        </AccountRolePermission>
    );
}
